import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    NEWS_REQUEST,
    NEWS_REQUEST_SUCCESS,
    NEWS_REQUEST_FAILURE,
    NEWS_FILTER,
    NEWS_EDIT,
    NEWS_ADD,
    NEWS_CANCEL,
    NEWS_UPSERT_REQUEST,
    NEWS_UPSERT_REQUEST_SUCCESS,
    NEWS_UPSERT_REQUEST_FAILURE
} from "../actions/news.actions";

const initialState = {
    news: [],
    filteredNews: [],
    newsItem: { id: -1 },
    isLoading: true,
    search: "",
    showDisabled: false,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setNews(state, news) {
    let newState = update(state, {
        news: { $set: news }
    });
    return newState;
}

function setFilter(state, search, showDisabled) {
    let newState = update(state, {
        search: { $set: search },
        showDisabled: { $set: showDisabled }
    });
    return newState;
}

function setFilteredNews(state) {
    let news = [...state.news];
    if (!state.showDisabled) {
        news = news.filter(f => f.enabled);
    }
    if (state.search !== "") {
        news = news.filter(f => {
            if (f.title) {
                if (f.title.toLowerCase().indexOf(state.search.toLowerCase()) != -1) {
                    return true;
                }
            }
            return false;
        });
    }
    let newState = update(state, {
        filteredNews: { $set: news }
    });
    return newState;
}

function setNewsItem(state, newsItem) {
    if (newsItem.id != -1) {
        if (newsItem.id == 0) {
            newsItem = new CreDtos.News();
            newsItem.id = 0;
            newsItem.enabled = true;
        }
    }
    let newState = update(state, {
        newsItem: { $set: newsItem }
    });
    return newState;
}

export default function news(state = initialState, action) {
    switch (action.type) {
        case NEWS_REQUEST:
            return loading(state, true);
        case NEWS_REQUEST_SUCCESS:
            return setFilteredNews(setNews(loading(state, false), action.news));
        case NEWS_REQUEST_FAILURE:
            return loading(state, false);
        case NEWS_FILTER:
            return setFilteredNews(setFilter(state, action.search, action.showDisabled));
        case NEWS_EDIT:
            return setNewsItem(state, action.news);
        case NEWS_ADD:
            return setNewsItem(state, { id: 0 });
        case NEWS_CANCEL:
            return setNewsItem(state, { id: -1 });
        case NEWS_UPSERT_REQUEST:
            return saving(state, true);
        case NEWS_UPSERT_REQUEST_SUCCESS:
            return saving(setNewsItem(state, { id: -1 }), false);
        case NEWS_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/news.ts